import React from "react";
import { Redirect, Route, RedirectProps } from "react-router";
import { StatusCode } from "../../components/generic";

type OwnProps = RedirectProps & {
};

interface OwnState {
}

export class RedirectWithStatus extends React.Component<OwnProps, OwnState> {

    public render() {
        return (
            <Route render={(routeProps) => {
                if (routeProps.staticContext) {
                    (routeProps.staticContext as any).url = this.props.to;
                }

                return (
                    <div>
                        <StatusCode staticContext={routeProps.staticContext} redirect />
                        <Redirect {...this.props} />
                    </div>
                );
            }}/>
          );
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/RedirectWithStatus.tsx